import { ComponentProps } from 'react';
import { useTranslation } from '@frontend/i18n';
import { CornersSetting } from './corners-setting';
import { HeightSetting } from './height-setting';
import { Setting } from './setting';

type Props = {
  cornersFieldProps: ComponentProps<typeof CornersSetting>;
  heightFieldProps: Omit<ComponentProps<typeof HeightSetting>, 'independent' | 'title'>;
};

export const ImageSetting = ({ cornersFieldProps, heightFieldProps }: Props) => {
  const { t } = useTranslation('content-composer');

  return (
    <Setting title={t('Image')}>
      <CornersSetting {...cornersFieldProps} />
      <HeightSetting {...heightFieldProps} />
    </Setting>
  );
};
